/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M7.4697 7.4697a.75.75 0 0 1 1.0606 0l3.7197 3.7196 3.7197-3.7196a.75.75 0 0 1 1.0606 1.0607L13.3107 12.25l3.7196 3.7197a.75.75 0 0 1 0 1.0606.75.75 0 0 1-1.0606 0L12.25 13.3107l-3.7197 3.7196a.75.75 0 0 1-1.0606-1.0606l3.7196-3.7197-3.7196-3.7197a.75.75 0 0 1 0-1.0606Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 24c6.6274 0 12-5.3726 12-12S18.6274 0 12 0 0 5.3726 0 12s5.3726 12 12 12Zm0-1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Reject'
);
